export default [
    { name: 'Click Parameter', id: 'click' },
    { name: 'Event Parameter', id: 'event' },
    { name: 'UPYIELD Parameter', id: 'yieldr' },
];
